import GlobalApi from "./globalApi";
import { combineFilters } from "./modulesCommon";

const TREE_LIST_DATA_MR_TYPE = "TREE_LIST_DATA_MR_TYPE";
const TREE_LIST_DATA_PROPERTY = "TREE_LIST_DATA_PROPERTY";

const TREE_LIST_DATA = "TREE_LIST_DATA";
const TREE_LIST_DATA_LOADED = "TREE_LIST_DATA_LOADED";

const NATIONAL_TREE_LIST_DATA = "NATIONAL_TREE_LIST_DATA";
const NATIONAL_TREE_LIST_DATA_LOADED = "NATIONAL_TREE_LIST_DATA_LOADED";

const treeListDataModule = {
    namespaced: true,
    state: () => ({
        treeListData: {},
        treeListDataMrType: null,
        treeListDataProperty: null,
        treeListDataLoaded: false,
        nationalTreeListData: null,
        nationalTreeListDataLoaded: false,
    }),
    actions: {
        setTreeListDataMrType({ commit }, treeListDataMrType) {
            return commit(TREE_LIST_DATA_MR_TYPE, treeListDataMrType);
        },
        setTreeListDataProperty({ commit }, treeListDataProperty) {
            return commit(TREE_LIST_DATA_PROPERTY, treeListDataProperty);
        },
        readMrAttributesForTreeView({ commit, state, rootState }, context) {
            let filters = combineFilters(rootState.patientQuery, rootState.caseQuery, rootState.advancedQueryCriteria);

            let type = state.treeListDataMrType;
            let property = state.treeListDataProperty;

            return GlobalApi.GetMrAttributesForTreeView(context, rootState, filters, type, property).then(function (result) {
                if (state.nationalTreeListData !== null) {
                    if (state.nationalTreeListData.mrAttributeWithParentRowViewModelList.length > 0)
                        commit(
                            TREE_LIST_DATA,
                            combineTreeListRootPropertiesLists(result.data, state.nationalTreeListData),
                        );
                } else commit(TREE_LIST_DATA, result.data);
                commit(TREE_LIST_DATA_LOADED, true);
            });
        },
        readMrAttributesNationalDataForTreeView({ commit, state, rootState }) {
            let filters = combineFilters(rootState.patientQuery, rootState.caseQuery, rootState.advancedQueryCriteria);

            return GlobalApi.GetMrAttributesNationalDataForTreeView(filters, state.treeListDataMrType, state.treeListDataProperty).then(function (
                result,
            ) {
                if (Object.entries(state.treeListData).length !== 0 && state.treeListData.constructor !== Object)
                    if (state.treeListData.mrAttributePropertyWithParentStatistics.length > 0)
                        commit(TREE_LIST_DATA, combineTreeListRootPropertiesLists(state.treeListData, result.data));

                commit(NATIONAL_TREE_LIST_DATA, result.data);
                commit(NATIONAL_TREE_LIST_DATA_LOADED, true);
            });
        },
        setTreeListDataLoaded({ commit }, treeListDataLoaded) {
            commit(TREE_LIST_DATA_LOADED, treeListDataLoaded);
        },
    },
    mutations: {
        [TREE_LIST_DATA_MR_TYPE](state, treeListDataMrType) {
            state.treeListDataMrType = treeListDataMrType;
        },
        [TREE_LIST_DATA_PROPERTY](state, treeListDataProperty) {
            state.treeListDataProperty = treeListDataProperty;
        },

        [TREE_LIST_DATA](state, treeListData) {
            state.treeListData = treeListData;
        },
        [TREE_LIST_DATA_LOADED](state, treeListdataLoaded) {
            state.treeListDataLoaded = treeListdataLoaded;
        },

        [NATIONAL_TREE_LIST_DATA](state, nationalTreeListData) {
            state.nationalTreeListData = nationalTreeListData;
        },
        [NATIONAL_TREE_LIST_DATA_LOADED](state, nationalTreeListDataLoaded) {
            state.nationalTreeListDataLoaded = nationalTreeListDataLoaded;
        },
    },
};

const clone = (objectsArray) => JSON.parse(JSON.stringify(objectsArray));

function combineTreeListRootPropertiesLists(contextRootPropertiesList, nationalRootPropertiesList) {
    // will contain combined context and national properties
    let combined = {
        propertiesMaxPercent: 0,
        mrAttributeWithParentRowViewModelList: [],
    };

    // will contain not merged national properties
    let nationalRootPropertiesListClone = clone(nationalRootPropertiesList.mrAttributeWithParentRowViewModelList);
    // looping through all context properties
    // merging every property with related record
    // from national properties
    contextRootPropertiesList.mrAttributeWithParentRowViewModelList.forEach(function (contextProperty) {
        nationalRootPropertiesListClone.forEach(function (nationalProperty, index, nationalPropertiesArr) {

            // related national property was found,
            // merging context and national property together
            // and pushing it to the combined array
            if (contextProperty.name.toLowerCase() === nationalProperty.name.toLowerCase()) {
                let temp = {
                    id: contextProperty.id,
                    parentId: contextProperty.parentId,
                    name: contextProperty.name,
                    count: contextProperty.count,
                    percent: contextProperty.percent,
                    relativePercent: contextProperty.relativePercent,
                    isLeaf: contextProperty.isLeaf,
                    nationalCount: nationalProperty.count,
                    nationalPercent: nationalProperty.percent,
                    nationalRelativePercent: nationalProperty.relativePercent,
                };

                combined.mrAttributeWithParentRowViewModelList.push(temp);
                // removing merged national property
                // from national properties array clone
                nationalPropertiesArr.splice(index, 1);
            }
        });
    });

    combined.mrAttributeWithParentRowViewModelList.forEach(function (elem) {
        if (elem.percent > combined.propertiesMaxPercent) combined.propertiesMaxPercent = elem.percent;
    });

    return combined;
}
export default treeListDataModule;
